import { render, staticRenderFns } from "./Outrights.vue?vue&type=template&id=7a679684"
import script from "./Outrights.vue?vue&type=script&lang=js"
export * from "./Outrights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports